import { RegistrationStatus } from './registration-status.enum';

export enum CadastroStatusVenda {
  PRONTO_PARA_FECHAR_CONTRATO = 'PRONTO_PARA_FECHAR_CONTRATO',
  CONTRATO_FECHADO = 'CONTRATO_FECHADO'
}


export type CadastroStatusVendaType = CadastroStatusVenda | RegistrationStatus;
